import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

export default (assetId, callback) => {
  commitMutation(getEnvironment(), {
    mutation: graphql`
      mutation DeleteShowcaseAssetMutation($input: DeleteShowcaseAssetInput!) {
        deleteShowcaseAsset(input: $input) {
          isDeleted
        }
      }
    `,
    variables: {
      input: {
        assetId
      }
    },
    onCompleted: (response, errors) => {
      callback(response.deleteShowcaseAsset, errors);
    }
  });
};
